<template>
  <div class="container">
    <Search :searchParams="searchParams" @searchFn="searchFn" />

    <Empty v-if="finished && list.length <= 0" />
    <div class="list" v-else>
      <van-list
        :loading="loading"
        :finished="finished"
        :error="error"
        finished-text="没有更多了"
        error-text="请求失败"
        :immediate-check='false'
        @load="getData"
      >
        <Item
          v-for="(item, index) in list"
          :key="index"
          :itemData="item" />
      </van-list>
    </div>
  </div>
</template>

<script>
import Search from '@/components/search.vue';
import Item from '@/components/hospital/diagnosisItem.vue';
import Empty from '@/components/empty.vue';

import { getRegionDiagnosePage } from '@/api/promptness/consult';

export default {
  components: {
    Search,
    Item,
    Empty,
  },
  data() {
    return {
      searchParams: {
        readOnly: false,
        placeholder: '请输入诊断名称或首字母拼音',
        query: '',
        focus: false,
        type: 'search',
      },
      loading: false,
      finished: false,
      error: false,
      list: [],
      pageSize: 30,
      currentPage: 1,
    };
  },
  mounted() {
    this.searchParams.query = this.$route.query.name;
    const { shopCity, } = this.$route.query
    this.$store.commit('title', `${shopCity}医保诊断`);
    this.getData();
  },
  unmounted() {
    this.$store.commit('title', '');
  },
  methods: {
    getData(refreshing) {
      if (this.loading) return;
      this.loading = true;

      if (refreshing) {
        this.finished = false;
        this.currentPage = 1;
        this.list = [];
      }

      if (this.finished) return;

      const { diagnoseType, shopId, select, } = this.$route.query;

      getRegionDiagnosePage({
        diagnoseKeyword: this.searchParams.query,
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        diagnoseType: diagnoseType * 1,
        shopId,
      }).then((res) => {
        if (res && res.code === 200) {
          this.list = [...this.list, ...res.data.content];
          this.loading = false;
          let diagnoseCode = '';
          if (select) {
            diagnoseCode = select;
          } else {
            const selected = this.$store.state.diagnoseItem.find((item) => item.selected) || {};
            diagnoseCode = selected.diagnoseCode;
          }

          // eslint-disable-next-line no-plusplus
          for (let i = 0; i < this.list.length; i++) {
            if (this.list[i].diagnoseCode === diagnoseCode) {
              this.list[i].selected = true;
              break;
            }
          }

          // 判断是否加载完毕
          if (res.data.totalCount <= this.list.length) {
            this.finished = true;
          } else {
            this.currentPage += 1;
          }
        } else {
          this.error = true;
          this.loading = false;
          this.finished = false;
        }
      });
    },
    searchFn(val) {
      this.searchParams.query = val;
      this.getData(true);
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  height: calc(100vh - 44px);
  overflow: auto;
  background: white;
}

.list {
  margin-top: 52px;
}

.van-pull-refresh {
  overflow: auto;
}
</style>
